// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimilarSection_container__qXlzc {
  max-width: 1400px;
  margin: 0 auto;
  border-radius: 12px;
}

.SimilarSection_headerContainer__yYPzX {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.SimilarSection_title__IfrZr {
  color: white;
  font-size: 24px;
  margin: 0;
}

.SimilarSection_viewAll__ixmnI {
  color: white;
  text-decoration: none;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.SimilarSection_viewAll__ixmnI:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Swiper specific styles */
.SimilarSection_swiperContainer__9MgN3 {
  width: 100%;
  padding: 20px 0;
  overflow: hidden;
}

.SimilarSection_seriesItem__lbgJz {
  position: relative;
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  height: 100%;
  display: flex;
  justify-content: center;
}

.SimilarSection_seriesItem__lbgJz:hover {
  transform: scale(1.05);
}

.SimilarSection_seriesImage__KZ5CC {
  width: 100%;
  max-width: 200px;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

/* Navigation controls */
.SimilarSection_navigationControls__NR7Be {
  display: flex;
  gap: 10px;
  align-items: center;
}

.SimilarSection_navButton__Q2hGN {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  transition: background-color 0.3s ease;
}

.SimilarSection_navButton__Q2hGN:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.SimilarSection_navButton__Q2hGN.SimilarSection_swiper-button-disabled__TJkDo {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Loading and error states */
.SimilarSection_loadingContainer__HH6N0 {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SimilarSection_errorMessage__i6HxB {
  color: white;
  text-align: center;
  padding: 20px;
}

/* Responsive styles */
@media (max-width: 1200px) {
  .SimilarSection_container__qXlzc {
    margin: 0 16px;
  }
}

@media (max-width: 768px) {
  .SimilarSection_seriesImage__KZ5CC {
    max-width: 160px;
    height: auto;
  }
  
  .SimilarSection_title__IfrZr {
    font-size: 20px;
  }
  
  .SimilarSection_container__qXlzc {
    margin: 0 12px;
    padding: 16px;
  }
  
  .SimilarSection_navButton__Q2hGN {
    width: 32px;
    height: 32px;
  }
}

@media (max-width: 480px) {
  .SimilarSection_seriesImage__KZ5CC {
    max-width: 100%;
    height: auto;
  }
  .SimilarSection_headerContainer__yYPzX{
    margin-bottom: 0px;
  }
  .SimilarSection_title__IfrZr {
    font-size: 16px;
  }
  
  .SimilarSection_container__qXlzc {
    margin: 0 8px;
    padding: 12px;
  }
  
  .SimilarSection_navButton__Q2hGN {
    width: 28px;
    height: 28px;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/pages/Audio/Component/CSS/SimilarSection.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF","sourcesContent":[".container {\n  max-width: 1400px;\n  margin: 0 auto;\n  border-radius: 12px;\n}\n\n.headerContainer {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.title {\n  color: white;\n  font-size: 24px;\n  margin: 0;\n}\n\n.viewAll {\n  color: white;\n  text-decoration: none;\n  font-size: 14px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.viewAll:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Swiper specific styles */\n.swiperContainer {\n  width: 100%;\n  padding: 20px 0;\n  overflow: hidden;\n}\n\n.seriesItem {\n  position: relative;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  border-radius: 8px;\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.seriesItem:hover {\n  transform: scale(1.05);\n}\n\n.seriesImage {\n  width: 100%;\n  max-width: 200px;\n  height: auto;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n/* Navigation controls */\n.navigationControls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.navButton {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  transition: background-color 0.3s ease;\n}\n\n.navButton:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.navButton.swiper-button-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Loading and error states */\n.loadingContainer {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.errorMessage {\n  color: white;\n  text-align: center;\n  padding: 20px;\n}\n\n/* Responsive styles */\n@media (max-width: 1200px) {\n  .container {\n    margin: 0 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .seriesImage {\n    max-width: 160px;\n    height: auto;\n  }\n  \n  .title {\n    font-size: 20px;\n  }\n  \n  .container {\n    margin: 0 12px;\n    padding: 16px;\n  }\n  \n  .navButton {\n    width: 32px;\n    height: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .seriesImage {\n    max-width: 100%;\n    height: auto;\n  }\n  .headerContainer{\n    margin-bottom: 0px;\n  }\n  .title {\n    font-size: 16px;\n  }\n  \n  .container {\n    margin: 0 8px;\n    padding: 12px;\n  }\n  \n  .navButton {\n    width: 28px;\n    height: 28px;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SimilarSection_container__qXlzc`,
	"headerContainer": `SimilarSection_headerContainer__yYPzX`,
	"title": `SimilarSection_title__IfrZr`,
	"viewAll": `SimilarSection_viewAll__ixmnI`,
	"swiperContainer": `SimilarSection_swiperContainer__9MgN3`,
	"seriesItem": `SimilarSection_seriesItem__lbgJz`,
	"seriesImage": `SimilarSection_seriesImage__KZ5CC`,
	"navigationControls": `SimilarSection_navigationControls__NR7Be`,
	"navButton": `SimilarSection_navButton__Q2hGN`,
	"swiper-button-disabled": `SimilarSection_swiper-button-disabled__TJkDo`,
	"loadingContainer": `SimilarSection_loadingContainer__HH6N0`,
	"errorMessage": `SimilarSection_errorMessage__i6HxB`
};
export default ___CSS_LOADER_EXPORT___;
